/**
 * Leaving the application for ReservePay's hosted page.
 *
 * One line, in its own module, for two reasons.
 *
 * It is the **only place on this surface that navigates out of the app**, and
 * that is worth being able to point at: everything else here is an in-app route
 * change through `router.tsx`. A guest who follows this is gone, and comes back
 * as a fresh document to whatever `POKPOK_GUEST_RETURN_URL` says — which is why
 * the attempt record on disk exists at all.
 *
 * And it is a **test seam, stated rather than smuggled**. `location.assign` is
 * unforgeable in jsdom — non-writable, non-configurable, impossible to spy on or
 * redefine — so the test that proves a guest is sent to ReservePay's own URL and
 * nowhere else needs a module boundary to stand on.
 *
 * `assign`, not `replace`: the back gesture must bring the guest back to Q8,
 * which knows there is an attempt open and can say so. `replace` would drop them
 * behind it, on the bill, with no sign a payment was ever started.
 */
export function leaveForPayment(url: string): void {
  globalThis.location.assign(url);
}
